var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRolesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7 5C5.7 2.6241 7.6241 0.7 10 0.7C12.3759 0.7 14.3 2.6241 14.3 5C14.3 7.3759 12.3759 9.3 10 9.3C7.6241 9.3 5.7 7.3759 5.7 5ZM0.7 16.25C0.7 15.6758 0.982058 15.1211 1.56792 14.5804C2.15854 14.0353 3.01006 13.553 4.00875 13.1529C6.00724 12.3523 8.41875 11.95 10 11.95C11.5812 11.95 13.9928 12.3523 15.9913 13.1529C16.9899 13.553 17.8415 14.0353 18.4321 14.5804C19.0179 15.1211 19.3 15.6758 19.3 16.25V19.3H0.7V16.25Z",
    stroke: "#3E3E3E",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2145 19.2858H25.7145V15.9796C25.7145 14.166 23.0913 12.9091 20.2778 12.2144",
    stroke: "#3E3E3E",
    strokeWidth: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7144 1.28564C18.8454 1.28564 20.5715 3.01172 20.5715 5.14279C20.5715 7.27386 18.8454 8.99993 16.7144 8.99993",
    stroke: "#3E3E3E",
    strokeWidth: 1.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolesIcon);
export default __webpack_public_path__ + "static/media/roles-icon.303f9801.svg";
export { ForwardRef as ReactComponent };